"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormControl = _interopRequireDefault(require("@mui/material/FormControl/FormControl.js"));

var _InputLabel = _interopRequireDefault(require("@mui/material/InputLabel/InputLabel.js"));

var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText/FormHelperText.js"));

var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem/MenuItem.js"));

var _Select = _interopRequireDefault(require("@mui/material/Select/Select.js"));

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

var _Colors = _interopRequireDefault(require("../../styles/Colors"));

var _ChevronDownIcon = _interopRequireDefault(require("../../assets/Icons/ChevronDownIcon"));

var _CheckIcon = _interopRequireDefault(require("../../assets/Icons/CheckIcon"));

var _excluded = ["label", "error", "disabled", "readOnly", "hint", "margin", "width", "selectOptions", "value", "children", "required"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _makeStyles.default)({
  select: {
    borderRadius: '4px',
    backgroundColor: _Colors.default.lightestGrey,
    fontSize: '15px',
    margin: 0,
    '&:focus': {
      backgroundColor: _Colors.default.lightestGrey
    }
  },
  icon: {
    right: '13px',
    top: 'calc(50% - 16px)'
  },
  labelRoot: {
    '& .isReadOnly': {
      opacity: 0.8
    },
    '& .isDisabled': {
      opacity: 0.5
    }
  },
  helperTextRoot: {
    fontFamily: 'Lato',
    fontSize: '11px',
    margin: '0 13px',
    position: 'absolute',
    bottom: '-16px',
    height: '16px',
    lineHeight: '16px',
    overflow: 'hidden',
    '& .isReadOnly': {
      opacity: 0.8
    },
    '& .isDisabled': {
      opacity: 0.5
    }
  },
  formControlRoot: function formControlRoot(_ref) {
    var multiple = _ref.multiple,
        margin = _ref.margin,
        width = _ref.width;
    return {
      height: multiple ? 'fit-content' : '56px',
      position: 'relative',
      margin: margin || 'none',
      width: width || '156px',
      borderRadius: '4px',
      '& .MuiFilledInput-underline': {
        borderRadius: '4px',
        '&:before': {
          borderBottom: "4px solid ".concat(_Colors.default.secondaryGrey, " !important"),
          borderRadius: '4px'
        },
        '&:after': {
          borderBottomWidth: "4px",
          borderRadius: '0px 0px 4px 4px'
        }
      },
      '& .isReadOnly': {
        opacity: 0.8
      },
      '& .isDisabled': {
        opacity: 0.5
      }
    };
  },
  gutters: {
    backgroundColor: _Colors.default.white,
    borderBottom: "1px solid ".concat(_Colors.default.lightGrey),
    position: 'relative',
    '&:last-child': {
      borderBottom: 'none'
    },
    '&:hover': {
      backgroundColor: '#fcfcfc'
    },
    '&:active': {
      borderLeft: "2px solid ".concat(_Colors.default.orange)
    }
  },
  selectedOptionIcon: {
    position: 'absolute',
    right: '12px'
  },
  selected: {
    backgroundColor: "".concat(_Colors.default.white, " !important") // No way around this one. Seems to be bug.

  },
  paper: {
    '&::-webkit-scrollbar': {
      width: '4px',
      borderRadius: '2px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: _Colors.default.secondaryGrey,
      width: '4px',
      borderRadius: '2px'
    }
  }
});

var getClasses = function getClasses(readOnly, disabled) {
  return "".concat(readOnly ? 'isReadOnly' : '', " ").concat(disabled ? 'isDisabled' : '');
};

var selectOption = function selectOption(value, label, isChecked, classes) {
  var gutters = classes.gutters,
      selectedOptionIcon = classes.selectedOptionIcon,
      selected = classes.selected;
  return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    key: value,
    classes: {
      gutters: gutters,
      selected: selected
    },
    value: value
  }, label, " ", isChecked && /*#__PURE__*/_react.default.createElement(_CheckIcon.default, {
    className: selectedOptionIcon,
    fill: _Colors.default.orange
  }));
};

var renderOptions = function renderOptions(value, classes, options) {
  if (!options) return null;
  return options.map(function (option) {
    return selectOption(option.value, option.label, option.value === value, classes);
  });
};

var renderSelectedValue = function renderSelectedValue(value, options) {
  var _options$find;

  return options === null || options === void 0 ? void 0 : (_options$find = options.find(function (option) {
    return option.value === value;
  })) === null || _options$find === void 0 ? void 0 : _options$find.label;
};

var Select = /*#__PURE__*/_react.default.forwardRef(function (_ref2, ref) {
  var label = _ref2.label,
      error = _ref2.error,
      disabled = _ref2.disabled,
      readOnly = _ref2.readOnly,
      hint = _ref2.hint,
      margin = _ref2.margin,
      width = _ref2.width,
      selectOptions = _ref2.selectOptions,
      value = _ref2.value,
      children = _ref2.children,
      required = _ref2.required,
      rest = _objectWithoutProperties(_ref2, _excluded);

  var classes = useStyles({
    margin: margin,
    width: width,
    multiple: rest.multiple
  });
  var select = classes.select,
      formControlRoot = classes.formControlRoot,
      helperTextRoot = classes.helperTextRoot,
      labelRoot = classes.labelRoot,
      paper = classes.paper,
      icon = classes.icon;
  return /*#__PURE__*/_react.default.createElement(_FormControl.default, {
    ref: ref,
    classes: {
      root: formControlRoot
    },
    variant: "filled",
    error: error,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
    classes: {
      root: labelRoot
    },
    className: getClasses(readOnly, disabled),
    required: required
  }, label), /*#__PURE__*/_react.default.createElement(_Select.default, _extends({
    className: getClasses(readOnly, disabled),
    variant: "filled",
    classes: {
      select: select,
      icon: icon
    },
    error: error,
    disabled: disabled,
    readOnly: readOnly,
    IconComponent: function IconComponent(props) {
      return /*#__PURE__*/_react.default.createElement(_ChevronDownIcon.default, _extends({}, props, {
        fill: _Colors.default.textElementGrey
      }));
    },
    value: value,
    renderValue: function renderValue(selected) {
      return renderSelectedValue(selected, selectOptions);
    },
    MenuProps: {
      PaperProps: {
        style: {
          maxHeight: 200
        }
      },
      classes: {
        paper: paper
      },
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      }
    }
  }, rest), children || renderOptions(value, classes, selectOptions)), /*#__PURE__*/_react.default.createElement(_FormHelperText.default, {
    classes: {
      root: helperTextRoot
    },
    className: getClasses(readOnly, disabled)
  }, hint));
});

var _default = Select;
exports.default = _default;